import getElement from './_getElement';
import config from './_config';

/**
 * @private
 */
const mapFieldNames = {
  street_number: 'short_name',
  route: 'long_name',
};

/**
 * Callback for the `place_changed` event.
 * @see https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
 *
 * @param {Object} autocomplete: an instance of `google.maps.places.Autocomplete`
 */
export default function onPlaceChanged(autocomplete) {
  let addressLabel = '';
  let addressType, fieldName;
  const place = autocomplete.getPlace();
  const inputAddress = getElement(config.inputAddress);
  (place.address_components || []).forEach((address) => {
    addressType = address.types[0];
    fieldName = mapFieldNames[addressType];
    if (fieldName) {
      addressLabel += `${address[fieldName]} `;
    }
  });
  if (inputAddress) {
    inputAddress.value = addressLabel;
  }
}
